"use client";

import React from "react";
import { ChevronRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  id: 1,
  question: "What types of businesses do you work with?",
  answer: "We serve small to mid-size enterprises and emerging entrepreneurs across various industries. Our consulting and educational services are tailored to each client's unique operational challenges and growth objectives."
}, {
  id: 2,
  question: "Are your educational services accredited?",
  answer: "Our educational services are non-accredited. We provide practical workshops and guidance focused on business operations, financial management, and strategic planning rather than formal certification programs."
}, {
  id: 3,
  question: "How do your consulting sessions work?",
  answer: "We offer one-on-one advisory sessions where we assess your current operations, identify challenges, and develop customized roadmaps. Sessions can be scheduled by appointment and are designed to provide actionable strategies tailored to your business needs."
}, {
  id: 4,
  question: "What is included in your workshops?",
  answer: "Our customized workshops cover topics such as business operational guidance, financial management improvement, and strategic planning development. Each workshop is designed to deliver practical insights and tools you can implement immediately."
}, {
  id: 5,
  question: "How can I get started with RESTORE AND HOPE LLC?",
  answer: "Getting started is simple. Contact us at 925-232-1539 or email info@restoreandhopellc.com to schedule an initial consultation. We'll discuss your needs and recommend the best approach to help you achieve sustainable growth."
}, {
  id: 6,
  question: "What makes your approach different?",
  answer: "We focus on practical, customized solutions that address real-world challenges. Our expertise in operational guidance and strategic planning ensures that every recommendation is actionable and aligned with your long-term growth goals."
}];
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section className="bg-background py-20 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <div ref={ref} className={`transition-all duration-300 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <h2 className="mb-2 text-center text-4xl font-semibold tracking-tight text-foreground">
            Frequently Asked Questions
          </h2>
          <p className="mb-12 text-center text-base text-muted-foreground">
            Find answers to common questions about our services and approach.
          </p>

          <Accordion type="single" collapsible className="space-y-0">
            {faqs.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className="border-b border-border-strong py-1">
                <AccordionTrigger className="group flex w-full items-center justify-between py-5 text-left text-lg font-medium text-foreground transition-all duration-250 hover:text-primary hover:no-underline focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
                  <span className="flex items-center gap-3">
                    <ChevronRight className="size-5 shrink-0 text-primary transition-transform duration-250 group-data-[state=open]:rotate-90" />
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="overflow-hidden text-base leading-relaxed text-muted-foreground transition-all duration-250 data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                  <div className="pl-8 pr-4 pb-5">{faq.answer}</div>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}